export const actions = {
    GET_ALL_LIMITS: "GET_ALL_LIMITS"
};

export const api = {
    GET_ALL_LIMITS: "/api/limits/list",
    GET_LIMITS_REPORT: "/api/limits/report",
    GET_CARD_LIMITS: "/api/limits/cardLimits",
    ADD_LIMIT: "/api/limits/add",
    EDIT_LIMIT: "/api/limits/edit",
    REMOVE_LIMIT: "/api/limits/remove"
}